import common from "./common"
import component_issue from "../assets/data/component_issue.json"

let apiControllers = {
    gunQuotationControllers(obj) {
        let employee = common.getEmployeeFromLocal()
        let payload = {
            client_id: obj.client_id,
            client_name: obj.company_name,
            client_email: obj.company_email,
            client_mobile: obj.company_mobile,
            client_address: obj.company_address,
            client_city: obj.city,
            client_state: obj.state,
            client_country: obj.client_country || "india",

            contact_person_name: obj.contact_person_name,
            contact_person_email: obj.contact_person_email,
            contact_person_phone: obj.contact_person_mobile,
            contact_person_designation: obj.contact_person_designation,

            quotations:
            {
                quotation_amt: Number(obj.price) * Number(obj.quantity),
                quotation_number: obj.quotation_number, // after getting quotation number from DB.
                quotation_id: obj.quotation_id, //mongo_id
                quotation_date: obj.quotation_date,
                product_type: obj.product_type || "Powder Coating Gun",
                product_type_slug: obj.product_type || "powder_coating_gun",
                employee_name: employee.full_name,
                employee_id: employee.employee_id,
                current_status: "Quotation Sent", // always will be set sa QUOTATION_CREATED
                quotation_url: obj.quotation_url, // PHASE_2
                components: [
                    {
                        item_slug: obj.item_slug || "powder_coating_gun",
                        item_name: obj.product || "Powder Coating Gun",
                        item_unit_price: Number(obj.price),
                        item_quantity: Number(obj.quantity),
                        item_total_price: Number(obj.price) * Number(obj.quantity),
                    }
                ],
            },
        }

        return payload
    },
    getAddClientPayload(obj) {
        let employee = common.getEmployeeFromLocal()

        let quote =
        {
            quotation_amt: Number(obj.price) * Number(obj.quantity),
            quotation_number: obj.quotation_number, // after getting quotation number from DB.
            quotation_id: obj.quotation_id, //mongo_id
            quotation_date: obj.quotation_date,
            product_type: obj.product_type || "Powder Coating Gun",
            product_type_slug: obj.product_type || "powder_coating_gun",
            employee_name: employee.full_name,
            employee_id: employee.employee_id,
            current_status: "Quotation Sent", // always will be set sa QUOTATION_CREATED
            quotation_url: obj.quotation_url, // PHASE_2
            components: [
                {
                    item_slug: obj.item_slug || "powder_coating_gun",
                    item_name: obj.product || "Powder Coating Gun",
                    item_unit_price: Number(obj.price),
                    item_quantity: Number(obj.quantity),
                    item_total_price: Number(obj.price) * Number(obj.quantity),
                }
            ],
        }

        let payload = {
            client_name: obj.company_name,
            client_slug: "havels",
            client_primary_email: obj.company_email,
            client_phone_code: "91",
            client_primary_phone: obj.company_mobile,
            client_address: {
                client_city: obj.city,
                client_state: obj.state,
                client_country: obj.client_country || "india",
                client_full_address: obj.company_address,
                client_country_code: "IND"
            },
            contact_person: [
                {
                    contact_person_name: obj.contact_person_name,
                    contact_person_email: obj.contact_person_email,
                    contact_person_phone: obj.contact_person_mobile,
                    contact_person_designation: obj.contact_person_designation,
                }
            ],
            quotations: [quote],
            created_by: {
                employee_name: employee.full_name,
                employee_id: employee.employee_id,
            },
            employee_updates: [
                {
                    epmloyee_name: employee.full_name,
                    epmloyee_id: employee.employee_id,
                    date: obj.quotation_date,
                    comment: "Quotation Created",
                }
            ],
        }

        return payload
    },
    getServicePayload(formData, serviceData) {
        let serviceReport = []
        Object.keys(serviceData).forEach((key) => {
            let isFine = serviceData[key].value === "Yes"
            let issue = component_issue.find(item => item.key === key)
            serviceReport.push({
                componentName: serviceData[key].displayName,
                componentSlug: key,
                componentId: null,
                componentIsWorking: isFine,
                serviceCheckId: issue ? issue.serviceCheckId : null,
                comment: serviceData[key].comment
            })
        })
        let payload = {
            "client_name": formData.companyName,
            "client_address": formData.companyAddress,
            "client_email": formData.companyEmail,
            "contact_person_name": formData.companyContactPerson,
            "contact_person_designation": formData.companyContactPersonDesignation,
            "contact_person_phone": formData.companyContactPersonMobile,
            "contact_person_email": formData.companyContactPersonEmail,
            "service_engineer_name": formData.serviceEngineername,
            "service_engineer_contact_number": formData.serviceEngineerNumber,
            "service_engineer_email": formData.serviceEngineerEmail,
            "service_engineer_employee_id":formData.service_engineer_employee_id,
            "date_of_service": formData.dateOfService,
            service_report: serviceReport
        }
        console.log(payload)
        return payload
    }
}


export default apiControllers;